export const icons = [
  {
    name: 'add_client',
    filename: 'add_client.svg',
  },
  {
    name: 'add_contact',
    filename: 'add_contact.svg',
  },
  {
    name: 'add_policy',
    filename: 'add_policy.svg',
  },
  {
    name: 'add_renewal',
    filename: 'add_renewal.svg',
  },
  {
    name: 'add_user',
    filename: 'add_user.svg',
  },
  {
    name: 'add',
    filename: 'add.svg',
  },
  {
    name: 'additional_products_thin',
    filename: 'additional_products_thin.svg',
  },
  {
    name: 'airside_liability_thin',
    filename: 'product_airside_liability_thin.svg',
  },
  {
    name: 'application_complete',
    filename: 'application_complete.svg',
  },
  {
    name: 'application_complete_thin',
    filename: 'application_complete_thin.svg',
  },
  {
    name: 'application_help',
    filename: 'application_help.svg',
  },
  {
    name: 'application_new',
    filename: 'application_new.svg',
  },
  {
    name: 'application_new_thin',
    filename: 'application_new_thin.svg',
  },
  {
    name: 'application_progress',
    filename: 'application_progress.svg',
  },
  {
    name: 'application_progress_thin',
    filename: 'application_progress_thin.svg',
  },
  {
    name: 'application_released',
    filename: 'application_released.svg',
  },
  {
    name: 'application_released_thin',
    filename: 'application_released_thin.svg',
  },
  {
    name: 'application_thin',
    filename: 'application_thin.svg',
  },
  {
    name: 'application_sent',
    filename: 'application_sent.svg',
  },
  {
    name: 'application_sent_thin',
    filename: 'application_sent_thin.svg',
  },
  {
    name: 'arrow_right',
    filename: 'arrow_right.svg',
  },
  {
    name: 'arrow_up',
    filename: 'arrow_up.svg',
  },
  {
    name: 'avatar',
    filename: 'avatar.svg',
  },
  {
    name: 'broker',
    filename: 'broker.svg',
  },
  {
    name: 'broker_thin',
    filename: 'broker_thin.svg',
  },
  {
    name: 'business_accident_health_thin',
    filename: 'product_business_accident_health_thin.svg',
  },
  {
    name: 'business_health_thin',
    filename: 'product_business_health_thin.svg',
  },
  {
    name: 'business_interruption_thin',
    filename: 'product_business_interruption_thin.svg',
  },
  {
    name: 'calculator_thin',
    filename: 'calculator_thin.svg',
  },
  {
    name: 'card_thin',
    filename: 'card_thin.svg',
  },
  {
    name: 'card_phone_thin',
    filename: 'card_phone_thin.svg',
  },
  {
    name: 'calendar',
    filename: 'calendar.svg',
  },
  {
    name: 'change',
    filename: 'change.svg',
  },
  {
    name: 'chevron_down',
    filename: 'chevron_down.svg',
  },
  {
    name: 'chevron_down_thin',
    filename: 'chevron_down_thin.svg',
  },
  {
    name: 'chevron_left_light',
    filename: 'chevron_left_light.svg',
  },
  {
    name: 'chevron_left_thin',
    filename: 'chevron_left_thin.svg',
  },
  {
    name: 'chevron_left',
    filename: 'chevron_left.svg',
  },
  {
    name: 'chevron_right_light',
    filename: 'chevron_right_light.svg',
  },
  {
    name: 'chevron_right_thin',
    filename: 'chevron_right_thin.svg',
  },
  {
    name: 'chevron_right',
    filename: 'chevron_right.svg',
  },
  {
    name: 'chevron_up',
    filename: 'chevron_up.svg',
  },
  {
    name: 'chevron_up_thin',
    filename: 'chevron_up_thin.svg',
  },
  {
    name: 'client_contact_thin',
    filename: 'client_contact_thin.svg',
  },
  {
    name: 'client_thin',
    filename: 'client_thin.svg',
  },
  {
    name: 'client',
    filename: 'client.svg',
  },
  {
    name: 'client_avatar_thin',
    filename: 'clientavatar_thin.svg',
  },
  {
    name: 'clock',
    filename: 'clock.svg',
  },
  {
    name: 'close_light',
    filename: 'close_light.svg',
  },
  {
    name: 'close',
    filename: 'close.svg',
  },
  {
    name: 'companies_thin',
    filename: 'companies_thin.svg',
  },
  {
    name: 'company_details_thin',
    filename: 'company_details_thin.svg',
  },
  {
    name: 'computer_thin',
    filename: 'product_computer_thin.svg',
  },
  {
    name: 'communications_thin',
    filename: 'communications_thin.svg',
  },
  {
    name: 'contamination_thin',
    filename: 'product_contamination_thin.svg',
  },
  {
    name: 'contract_thin',
    filename: 'product_contract_thin.svg',
  },
  {
    name: 'dando_thin',
    filename: 'product_dando_thin.svg',
  },
  {
    name: 'delete',
    filename: 'delete.svg',
  },
  {
    name: 'deterioration_stock_thin',
    filename: 'product_deterioration_stock_thin.svg',
  },
  {
    name: 'direct_debit_thin',
    filename: 'direct_debit_thin.svg',
  },
  {
    name: 'doc_sent',
    filename: 'doc_sent.svg',
  },
  {
    name: 'doc_sent_thin',
    filename: 'doc_sent_thin.svg',
  },
  {
    name: 'doc_upload_thin',
    filename: 'doc_upload_thin.svg',
  },
  {
    name: 'doc_upload',
    filename: 'doc_upload.svg',
  },
  {
    name: 'document_csv_thin',
    filename: 'document_csv_thin.svg',
  },
  {
    name: 'document_docx_thin',
    filename: 'document_docx_thin.svg',
  },
  {
    name: 'document_img_thin',
    filename: 'document_img_thin.svg',
  },
  {
    name: 'document_msg_thin',
    filename: 'document_msg_thin.svg',
  },
  {
    name: 'document_pdf_thin',
    filename: 'document_pdf_thin.svg',
  },
  {
    name: 'document_temp_thin',
    filename: 'document_temp_thin.svg',
  },
  {
    name: 'document_thin',
    filename: 'document_thin.svg',
  },
  {
    name: 'document_xlsx_thin',
    filename: 'document_xlsx_thin.svg',
  },
  {
    name: 'double_chevron',
    filename: 'double_chevron.svg',
  },
  {
    name: 'download',
    filename: 'download.svg',
  },
  {
    name: 'edit',
    filename: 'edit.svg',
  },
  {
    name: 'email',
    filename: 'email.svg',
  },
  {
    name: 'enquiry_thin',
    filename: 'enquiry_thin.svg',
  },
  {
    name: 'exclaim',
    filename: 'exclaim.svg',
  },
  {
    name: 'expire_pending',
    filename: 'expire_pending.svg',
  },
  {
    name: 'facebook',
    filename: 'facebook.svg',
  },
  {
    name: 'filter',
    filename: 'filter.svg',
  },
  {
    name: 'flag',
    filename: 'flag.svg',
  },
  {
    name: 'folder_add',
    filename: 'folder_add.svg',
  },
  {
    name: 'folder_thin',
    filename: 'folder_thin.svg',
  },
  {
    name: 'form_success',
    filename: 'form_success.svg',
  },
  {
    name: 'grid',
    filename: 'grid.svg',
  },
  {
    name: 'health_evaluation',
    filename: 'health_evaluation.svg',
  },
  {
    name: 'health_evaluation_thin',
    filename: 'health_evaluation_thin.svg',
  },
  {
    name: 'health_evaluation_accepted_thin',
    filename: 'health_evaluation_accepted_thin.svg',
  },
  {
    name: 'health_evaluation_declined_thin',
    filename: 'health_evaluation_declined_thin.svg',
  },
  {
    name: 'health_inprogress_thin',
    filename: 'health_inprogress_thin.svg',
  },
  {
    name: 'help',
    filename: 'help.svg',
  },
  {
    name: 'i',
    filename: 'i.svg',
  },
  {
    name: 'instructed',
    filename: 'instructed.svg',
  },
  {
    name: 'instructed_thin',
    filename: 'instructed_thin.svg',
  },
  {
    name: 'invoice_paid_universal_thin',
    filename: 'invoice_paid_universal_thin.svg',
  },
  {
    name: 'invoice_paid_universal',
    filename: 'invoice_paid_universal.svg',
  },
  {
    name: 'invoice_sent',
    filename: 'invoice_sent.svg',
  },
  {
    name: 'invoice_sent_universal_thin',
    filename: 'invoice_sent_universal_thin.svg',
  },
  {
    name: 'invoice_sent_universal',
    filename: 'invoice_sent_universal.svg',
  },
  {
    name: 'invoice_thin',
    filename: 'invoice_thin.svg',
  },
  {
    name: 'invoice_universal',
    filename: 'invoice_universal.svg',
  },
  {
    name: 'invoice_universal_thin',
    filename: 'invoice_universal_thin.svg',
  },
  {
    name: 'invoice_unpaid_universal_thin',
    filename: 'invoice_unpaid_universal_thin.svg',
  },
  {
    name: 'invoice_unpaid_universal',
    filename: 'invoice_unpaid_universal.svg',
  },
  {
    name: 'linkedin',
    filename: 'linkedin.svg',
  },
  {
    name: 'legal_thin',
    filename: 'product_legal_thin.svg',
  },
  {
    name: 'list',
    filename: 'list.svg',
  },
  {
    name: 'lsos',
    filename: 'lsos.svg',
  },
  {
    name: 'monthly_payment_thin',
    filename: 'monthly_payment_thin.svg',
  },
  {
    name: 'more_thin',
    filename: 'more_thin.svg',
  },
  {
    name: 'more',
    filename: 'more.svg',
  },
  {
    name: 'motorfleet_thin',
    filename: 'product_motorfleet_thin.svg',
  },
  {
    name: 'on_hold',
    filename: 'on_hold.svg',
  },
  {
    name: 'open',
    filename: 'open.svg',
  },
  {
    name: 'payment_fail_thin',
    filename: 'payment_fail_thin.svg',
  },
  {
    name: 'payment_progress',
    filename: 'payment_progress.svg',
  },
  {
    name: 'payment_success_thin',
    filename: 'payment_success_thin.svg',
  },
  {
    name: 'payment_success',
    filename: 'payment_success.svg',
  },
  {
    name: 'payment_thin',
    filename: 'payment_thin.svg',
  },
  {
    name: 'paymethod_thin',
    filename: 'paymethod_thin.svg',
  },
  {
    name: 'phone',
    filename: 'phone.svg',
  },
  {
    name: 'phone_thin',
    filename: 'phone_thin.svg',
  },
  {
    name: 'property_damage_thin',
    filename: 'product_property_damage_thin.svg',
  },
  {
    name: 'quote_bronze_thin',
    filename: 'quote_bronze_thin.svg',
  },
  {
    name: 'quote_silver_thin',
    filename: 'quote_silver_thin.svg',
  },
  {
    name: 'quote_gold_thin',
    filename: 'quote_gold_thin.svg',
  },
  {
    name: 'quote_onhold',
    filename: 'quote_onhold.svg',
  },
  {
    name: 'quote_onhold_thin',
    filename: 'quote_onhold_thin.svg',
  },
  {
    name: 'quote_requested',
    filename: 'quote_requested.svg',
  },
  {
    name: 'quote_requested_thin',
    filename: 'quote_requested_thin.svg',
  },
  {
    name: 'quote_universal_accepted_thin',
    filename: 'quote_universal_accepted_thin.svg',
  },
  {
    name: 'quote_universal_accepted',
    filename: 'quote_universal_accepted.svg',
  },
  {
    name: 'quote_universal_sent_thin',
    filename: 'quote_universal_sent_thin.svg',
  },
  {
    name: 'quote_universal_sent',
    filename: 'quote_universal_sent.svg',
  },
  {
    name: 'quote_universal_thin',
    filename: 'quote_universal_thin.svg',
  },
  {
    name: 'quote_universal',
    filename: 'quote_universal.svg',
  },
  {
    name: 'status',
    filename: 'status.svg',
  },
  {
    name: 'terrorism_thin',
    filename: 'product_terrorism_thin.svg',
  },
  {
    name: 'transit_thin',
    filename: 'product_transit_thin.svg',
  },
  {
    name: 'travel_accident_thin',
    filename: 'product_travel_accident_thin.svg',
  },
  {
    name: 'under_review',
    filename: 'under_review.svg',
  },
  {
    name: 'under_review_thin',
    filename: 'under_review_thin.svg',
  },
  {
    name: 'accident_thin',
    filename: 'product_accident_thealth_thin.svg',
  },
  {
    name: 'agriculture_thin',
    filename: 'product_agriculture_forestry_thin.svg',
  },
  {
    name: 'auto_motor_thin',
    filename: 'product_auto_motor_thin.svg',
  },
  {
    name: 'aviation_thin',
    filename: 'product_aviation_thin.svg',
  },
  {
    name: 'casualty_liability_thin',
    filename: 'product_casualty_liability_thin.svg',
  },
  {
    name: 'checkmate_thin',
    filename: 'product_checkmate_thin.svg',
  },
  {
    name: 'contingency_thin',
    filename: 'product_contingency_thin.svg',
  },
  {
    name: 'crime_thin',
    filename: 'product_crime_thin.svg',
  },
  {
    name: 'cyber_thin',
    filename: 'product_cyber_thin.svg',
  },
  {
    name: 'energy_thin',
    filename: 'product_energy_thin.svg',
  },
  {
    name: 'engineering_thin',
    filename: 'product_engineering_thin.svg',
  },
  {
    name: 'financial_thin',
    filename: 'product_financial_thin.svg',
  },
  {
    name: 'internal_accounting_thin',
    filename: 'product_internal_accounting_thin.svg',
  },
  {
    name: 'life_thin',
    filename: 'product_life_thin.svg',
  },
  {
    name: 'management_thin',
    filename: 'product_management_thin.svg',
  },
  {
    name: 'marine_thin',
    filename: 'product_marine_thin.svg',
  },
  {
    name: 'misc_thin',
    filename: 'product_misc_thin.svg',
  },
  {
    name: 'norway_thin',
    filename: 'product_norway_thin.svg',
  },
  {
    name: 'office_thin',
    filename: 'product_office_thin.svg',
  },
  {
    name: 'pensions_thin',
    filename: 'product_pensions_thin.svg',
  },
  {
    name: 'political_risk_thin',
    filename: 'product_politicalrisk_thin.svg',
  },
  {
    name: 'print',
    filename: 'print.svg',
  },
  {
    name: 'process_quote_thin',
    filename: 'product_process_quote_thin.svg',
  },
  {
    name: 'project_thin',
    filename: 'product_project_thin.svg',
  },
  {
    name: 'property_thin',
    filename: 'product_property_thin.svg',
  },
  {
    name: 'quote_thin',
    filename: 'product_quote_thin.svg',
  },
  {
    name: 'renewal_thin',
    filename: 'product_renewal_thin.svg',
  },
  {
    name: 'product_thin',
    filename: 'product_thin.svg',
  },
  {
    name: 'product_info_thin',
    filename: 'product_info_thin.svg',
  },
  {
    name: 'umbrella_thin',
    filename: 'product_umbrella_thin.svg',
  },
  {
    name: 'accident_health_thin',
    filename: 'product_accident_health_thin.svg',
  },
  {
    name: 'family_accident_health_thin',
    filename: 'product_family_accident_health_thin.svg',
  },
  {
    name: 'health_thin',
    filename: 'product_health_thin.svg',
  },
  {
    name: 'group_life_thin',
    filename: 'product_group_life_thin.svg',
  },
  {
    name: 'offices_thin',
    filename: 'product_offices_thin.svg',
  },
  {
    name: 'sick_leave_thin',
    filename: 'product_sick_leave_thin.svg',
  },
  {
    name: 'travel_business_thin',
    filename: 'product_travel_business_thin.svg',
  },
  {
    name: 'travel_thin',
    filename: 'product_travel_thin.svg',
  },
  {
    name: 'page_break',
    filename: 'page_break.svg',
  },
  {
    name: 'product',
    filename: 'product.svg',
  },
  {
    name: 'quote_error',
    filename: 'quote_error.svg',
  },
  {
    name: 'quote_sent_2',
    filename: 'quote_sent_2.svg',
  },
  {
    name: 'quote_sent',
    filename: 'quote_sent.svg',
  },
  {
    name: 'quote_thin',
    filename: 'quote_thin.svg',
  },
  {
    name: 'quote',
    filename: 'quote.svg',
  },
  {
    name: 'rate_bad_thin',
    filename: 'rate_bad_thin.svg',
  },
  {
    name: 'rate_good_thin',
    filename: 'rate_good_thin.svg',
  },
  {
    name: 'rate_neutral_thin',
    filename: 'rate_neutral_thin.svg',
  },
  {
    name: 'rate_neutral',
    filename: 'rate_neutral.svg',
  },
  {
    name: 'rate_vbad_thin',
    filename: 'rate_vbad_thin.svg',
  },
  {
    name: 'rate_vgood_thin',
    filename: 'rate_vgood_thin.svg',
  },
  {
    name: 'renewal_complete',
    filename: 'renewal_complete.svg',
  },
  {
    name: 'renewal',
    filename: 'renewal.svg',
  },
  {
    name: 'restore_trash',
    filename: 'restore_trash.svg',
  },
  {
    name: 'restore',
    filename: 'restore.svg',
  },
  {
    name: 'row_insert_bottom',
    filename: 'row_insert_bottom.svg',
  },
  {
    name: 'row_insert_top',
    filename: 'row_insert_top.svg',
  },
  {
    name: 'save',
    filename: 'save.svg',
  },
  {
    name: 'search',
    filename: 'search.svg',
  },
  {
    name: 'share_thin',
    filename: 'share_thin.svg',
  },
  {
    name: 'summary_thin',
    filename: 'summary_thin.svg',
  },
  {
    name: 'temporray_doc_thin',
    filename: 'temporray_doc_thin.svg',
  },
  {
    name: 'tick',
    filename: 'tick.svg',
  },
  {
    name: 'tick_thin',
    filename: 'tick_thin.svg',
  },
  {
    name: 'topup_thin',
    filename: 'topup_thin.svg',
  },
  {
    name: 'trash',
    filename: 'trash.svg',
  },
  {
    name: 'twitter',
    filename: 'twitter.svg',
  },
  {
    name: 'user_disabled',
    filename: 'user_disabled.svg',
  },
  {
    name: 'view_doc',
    filename: 'view_doc.svg',
  },
  {
    name: 'view_policy',
    filename: 'view_policy.svg',
  },
  {
    name: 'visibility_hidden',
    filename: 'visibility_hidden.svg',
  },
  {
    name: 'visibility',
    filename: 'visibility.svg',
  },
  {
    name: 'renewal_ntu',
    filename: 'renewal_ntu.svg',
  },
  {
    name: 'renewal_ntu_thin',
    filename: 'renewal_ntu_thin.svg',
  },
];
